(() => {
  if (customElements.get('aquarium-builder-kit')) return;
  const css = document.createElement('style');
  css.textContent = '.abk .abk-ess__thumb{position:relative;flex:0 0 64px;height:64px;border-radius:12px;border:1px solid #e6e8ea;background:#fff;display:grid;place-items:center;overflow:hidden}.abk .abk-ess__thumb img{width:100%;height:100%;object-fit:contain}.abk .abk-same{margin:4px 0 8px;font-size:13px;color:#5b636a}.abk .abk-ess__thumb b{position:absolute;right:3px;bottom:3px;min-width:20px;height:18px;padding:0 5px;border-radius:9px;background:#021429;color:#fff;font-size:11px;line-height:18px;text-align:center}';
  document.head.appendChild(css);

  const ICONS = {
    bulb: '<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>',
    filter: '<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M10 7h4M10 11h4M10 15h4"/>',
    pump: '<rect x="4" y="8" width="13" height="10" rx="2"/><path d="M17 11h3M8 8V5h5v3"/><circle cx="10.5" cy="13" r="2"/>',
    wave: '<path d="M2 9c2-2 4-2 6 0s4 2 6 0 4-2 6 0M2 15c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>',
    thermo: '<path d="M14 14.8V5a2 2 0 0 0-4 0v9.8a4 4 0 1 0 4 0z"/><path d="M12 9v8"/>',
    drop: '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>',
    shield: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/>',
    tub: '<path d="M5 8h14l-1.5 12h-11z"/><path d="M4 5h16v3H4z"/>',
    bottle: '<path d="M10 3h4v3l2 3v11a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9l2-3z"/><path d="M8 13h8"/>',
    fish: '<path d="M3 12c3-5 9-6 13-3l5-3v12l-5-3c-4 3-10 2-13-3z"/><circle cx="8" cy="11" r="1"/>',
    flask: '<path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3"/><path d="M7.5 15h9"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
    star: '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/>',
    ruler: '<path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/>',
    box: '<path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/>',
    sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    tag: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/>'
  };
  const icon = (name, size = 18) => `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[name] || ''}</svg>`;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const FALLBACK = {good: ['good', 'better', 'best'], better: ['better', 'good', 'best'], best: ['best', 'better', 'good']};

  class AquariumBuilderKit extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: this.dataset.currency || 'GBP'});
      this.mainVariants = JSON.parse(this.querySelector('[data-main-variants]')?.textContent || '[]');
      try {
        const data = await (await fetch(this.dataset.kitsUrl, {headers: {Accept: 'application/json'}})).json();
        const kit = data.kits?.[this.dataset.handle];
        if (!kit) return this.remove();
        this.data = data;
        this.kit = kit;
        const handles = [...new Set(kit.slots.flatMap(slot => Object.values(slot.picks).flatMap(pick => pick.items.map(item => item.handle))))];
        const root = this.dataset.rootUrl.replace(/\/$/, '');
        const products = await Promise.all(handles.map(handle => fetch(`${root}/products/${handle}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null)));
        this.products = Object.fromEntries(handles.map((handle, i) => [handle, products[i]]));
        this.tier = data.default_tier || 'better';
        this.overrides = {};
        this.removed = new Set();
        this.bind();
        this.render();
        this.hidden = false;
      } catch (error) {
        this.remove();
      }
    }

    bind() {
      this.addEventListener('click', event => {
        const tier = event.target.closest('[data-tier]');
        if (tier) { this.tier = tier.dataset.tier; this.overrides = {}; this.render(); return; }
        const swap = event.target.closest('[data-swap]');
        if (swap) { this.overrides[swap.dataset.slot] = swap.dataset.swap; this.render(); return; }
        const toggle = event.target.closest('[data-toggle]');
        if (toggle) {
          const slot = toggle.dataset.toggle;
          this.removed.has(slot) ? this.removed.delete(slot) : this.removed.add(slot);
          this.render();
          return;
        }
        if (event.target.closest('[data-add]')) this.addToBasket();
      });
      document.addEventListener('change', () => setTimeout(() => this.renderSummary(), 0));
      window.matchMedia('(max-width: 760px)').addEventListener('change', () => this.render());
    }

    variant(item) {
      const product = this.products[item.handle];
      const variant = product?.variants.find(v => Number(v.id) === Number(item.variant));
      return variant ? {product, variant} : null;
    }

    available(pick) { return pick.items.every(item => this.variant(item)?.variant.available); }

    price(pick) {
      const off = (this.data.discount_percent || 0) / 100;
      let was = 0, now = 0;
      for (const item of pick.items) {
        const found = this.variant(item);
        if (!found) continue;
        const line = found.variant.price * item.qty;
        was += line;
        now += item.discount ? Math.round(line * (1 - off)) : line;
      }
      return {was, now};
    }

    resolve(slot, tier, useOverrides = true) {
      const wanted = (useOverrides && this.overrides[slot.slot]) || tier;
      for (const key of FALLBACK[wanted]) {
        if (slot.picks[key] && this.available(slot.picks[key])) return {key, wanted, pick: slot.picks[key], swapped: key !== wanted};
      }
      return {key: wanted, wanted, pick: slot.picks[wanted], unavailable: true};
    }

    tierTotals(tier) {
      let was = 0, now = 0, swaps = 0;
      for (const slot of this.kit.slots) {
        const r = this.resolve(slot, tier, false);
        if (r.unavailable) continue;
        if (r.swapped) swaps += 1;
        const p = this.price(r.pick);
        was += p.was; now += p.now;
      }
      return {was, now, swaps};
    }

    label(tierId) { return this.data.tiers.find(t => t.id === tierId)?.label || tierId; }
    // Tiers that use the same pick as this one, e.g. "Better · Best", so a shared pick reads as deliberate.
    sharedKeys(slot, key) { return ['good', 'better', 'best'].filter(k => slot.picks[k] && slot.picks[k].label === slot.picks[key].label); }
    tierNames(slot, key) { return this.sharedKeys(slot, key).map(k => this.label(k)).join(' · '); }
    fmt(cents) { return this.money.format(cents / 100); }
    heading() { return this.kit.heading || 'Your aquarium setup'; }

    image(pick, size) {
      const src = this.variant(pick.items[0])?.product.featured_image;
      if (!src) return '';
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(size * 2));
      return `<img src="${esc(url.href)}" alt="" width="${size}" height="${size}" loading="lazy">`;
    }

    priceHtml(pick) {
      const p = this.price(pick);
      const save = p.was - p.now;
      return `<span class="abk-price"><strong>${this.fmt(p.now)}</strong>${save > 0 ? `<s>${this.fmt(p.was)}</s><em>Save ${this.fmt(save)}</em>` : ''}</span>`;
    }

    stockHtml(r) {
      if (r.unavailable) return `<span class="abk-stock abk-stock--out">${icon('clock', 14)}Out of stock</span>`;
      if (r.swapped) return `<span class="abk-stock abk-stock--swap">${icon('clock', 14)}Our ${esc(this.label(r.wanted))} pick is out of stock, so we've added the ${esc(this.label(r.key))} pick</span>`;
      return `<span class="abk-stock">${icon('check', 14)}In stock</span>`;
    }

    card(slot) {
      const r = this.resolve(slot, this.tier);
      const off = this.removed.has(slot.slot);
      const seen = new Set([r.pick.label]);
      const others = ['good', 'better', 'best'].filter(k => slot.picks[k] && !seen.has(slot.picks[k].label) && seen.add(slot.picks[k].label)).map(k => {
        const pick = slot.picks[k];
        const ok = this.available(pick);
        return `<button type="button" class="abk-alt" data-slot="${esc(slot.slot)}" data-swap="${k}" ${ok ? '' : 'disabled'}><span class="abk-pill abk-pill--${k}">${esc(this.tierNames(slot, k))}</span><span class="abk-alt__name">${esc(pick.label)}</span><strong>${ok ? this.fmt(this.price(pick).now) : 'Out of stock'}</strong></button>`;
      }).join('');
      const same = this.sharedKeys(slot, r.key);
      const fits = r.pick.fits.map(f => `<li>${icon('check', 14)}<span>${esc(f)}</span></li>`).join('');
      const evidence = r.pick.evidence ? `<li class="abk-evidence">${icon('star', 14)}<span>${esc(r.pick.evidence)}</span></li>` : '';
      return `<article class="abk-card${off ? ' is-removed' : ''}">
        <header><span class="abk-card__slot">${icon(slot.icon)}${esc(slot.slot)}<span class="abk-pill abk-pill--${r.key}">${esc(this.tierNames(slot, r.key))}</span></span><span class="abk-fit">${icon('check', 13)}Fits this tank</span></header>
        <div class="abk-card__body"><span class="abk-card__img">${this.image(r.pick, 96)}</span>
          <div class="abk-card__info"><a class="abk-card__title" href="${esc(this.variant(r.pick.items[0])?.product.url || '#')}">${esc(r.pick.label)}</a><ul>${fits}${evidence}</ul>${same.length > 1 ? `<p class="abk-same">The same pick in our ${esc(same.map(k => this.label(k)).join(' and '))} kits</p>` : ''}${this.priceHtml(r.pick)}${this.stockHtml(r)}</div></div>
        ${others ? `<div class="abk-alts">${others}</div>` : ''}
        <button type="button" class="abk-remove" data-toggle="${esc(slot.slot)}">${off ? 'Add back to kit' : 'Remove from kit'}</button>
      </article>`;
    }

    essentialRow(slot) {
      const r = this.resolve(slot, this.tier);
      const off = this.removed.has(slot.slot);
      return `<div class="abk-ess__row${off ? ' is-removed' : ''}"><span class="abk-ess__icon">${icon(slot.icon)}</span><span class="abk-ess__slot">${esc(slot.slot)}</span>
        <a class="abk-ess__thumb" href="${esc(this.variant(r.pick.items[0])?.product.url || '#')}" tabindex="-1" aria-hidden="true">${this.image(r.pick, 64)}${r.pick.items.length > 1 ? `<b>+${r.pick.items.length - 1}</b>` : ''}</a>
        <span class="abk-ess__info"><strong>${esc(r.pick.label)}</strong><span>${esc(r.pick.fits[0] || '')}${r.pick.evidence ? ' · ' + esc(r.pick.evidence) : ''}</span>${r.swapped || r.unavailable ? this.stockHtml(r) : ''}</span>
        ${this.priceHtml(r.pick)}<button type="button" class="abk-remove abk-remove--small" data-toggle="${esc(slot.slot)}">${off ? 'Add' : 'Remove'}</button></div>`;
    }

    mainVariant() {
      const id = Number(document.querySelector('form[action*="/cart/add"] [name="id"]')?.value);
      return this.mainVariants.find(v => Number(v.id) === id) || this.mainVariants[0];
    }

    render() {
      const mobile = typeof this.renderMobile === 'function' && window.matchMedia('(max-width: 760px)').matches;
      this.classList.toggle('is-mobile', mobile);
      if (mobile) return this.renderMobile();
      this.step = null;
      document.documentElement.classList.remove('abk-lock');
      ['[data-mobile]', '[data-stepper]'].forEach(s => { const el = this.querySelector(s); if (el) el.innerHTML = ''; });
      const tiers = this.data.tiers.map(t => {
        const totals = this.tierTotals(t.id);
        const on = t.id === this.tier;
        return `<button type="button" role="radio" aria-checked="${on}" class="abk-tier${on ? ' is-on' : ''}" data-tier="${t.id}">
          <span class="abk-tier__top"><span class="abk-pill abk-pill--${t.id}">${esc(t.label)}</span><span class="abk-radio"></span></span>
          <strong>${this.fmt(totals.now)}</strong>${totals.was > totals.now ? `<s>${this.fmt(totals.was)}</s>` : ''}
          <span class="abk-tier__copy">${esc(t.copy)}</span>
          <span class="abk-tier__stock${totals.swaps ? ' is-warn' : ''}">${totals.swaps ? `${totals.swaps} out-of-stock pick${totals.swaps > 1 ? 's' : ''} swapped` : 'All in stock'}</span></button>`;
      }).join('');
      const signals = (this.kit.signals || []).map(([a, b], i) => `<span class="abk-signal">${icon(['ruler', 'star', 'box'][i] || 'check')}<span><strong>${esc(a)}</strong><span>${esc(b)}</span></span></span>`).join('');
      const equipment = this.kit.slots.filter(s => s.group === 'equipment').map(s => this.card(s)).join('');
      const essentials = this.kit.slots.filter(s => s.group !== 'equipment').map(s => this.essentialRow(s)).join('');
      this.querySelector('[data-tiers]').innerHTML = tiers;
      this.querySelector('[data-signals]').innerHTML = signals;
      this.querySelector('[data-grid]').innerHTML = equipment + `<article class="abk-ess"><header><strong>Essentials for the first fill</strong><span>Sized for this tank · included in every kit</span></header>${essentials}</article>`;
      this.renderSummary();
    }

    renderSummary() {
      if (!this.kit) return;
      if (this.classList.contains('is-mobile')) return this.renderMobile();
      const tank = this.mainVariant();
      let was = 0, now = 0, count = 0;
      const lines = this.kit.slots.filter(s => !this.removed.has(s.slot)).map(slot => {
        const r = this.resolve(slot, this.tier);
        if (r.unavailable) return '';
        const p = this.price(r.pick);
        was += p.was; now += p.now; count += 1;
        return `<li><span>${esc(slot.slot)}</span><span>${p.was > p.now ? `<s>${this.fmt(p.was)}</s>` : ''}${this.fmt(p.now)}</span></li>`;
      }).join('');
      const tankPrice = Number(tank?.price || 0);
      this.querySelector('[data-summary]').innerHTML = `
        <header><strong>${esc(this.heading())}</strong><span class="abk-pill abk-pill--${this.tier}">${esc(this.label(this.tier))}</span></header>
        <div class="abk-sum__tank"><span>${esc(this.dataset.title)}${tank && tank.title !== 'Default Title' ? `<small>${esc(tank.title)}</small>` : ''}</span><strong>${this.fmt(tankPrice)}</strong></div>
        <p class="abk-sum__eyebrow">${esc(this.label(this.tier).toUpperCase())} KIT · ${count} SLOTS</p><ul>${lines}</ul>
        ${was > now ? `<div class="abk-sum__save">${icon('tag', 20)}<span><strong>You save ${this.fmt(was - now)} on the kit</strong><small>Builder discount on eligible items, applied in your basket</small></span></div>` : ''}
        <div class="abk-sum__total"><span>Total</span><strong>${this.fmt(tankPrice + now)}</strong></div>
        <button type="button" class="abk-add" data-add>Add tank + kit to basket</button>
        <p class="abk-status" data-status role="status" aria-live="polite"></p>`;
    }

    async addToBasket() {
      const status = this.querySelector('[data-status]');
      const button = this.querySelector('[data-add]');
      const tank = this.mainVariant();
      if (!tank) { status.textContent = 'Choose a colour and cabinet first.'; return; }
      const items = [{id: Number(tank.id), quantity: 1}];
      for (const slot of this.kit.slots) {
        if (this.removed.has(slot.slot)) continue;
        const r = this.resolve(slot, this.tier);
        if (r.unavailable) continue;
        for (const item of r.pick.items) items.push({id: Number(item.variant), quantity: item.qty, properties: {_builder_kit: this.label(this.tier)}});
      }
      button.disabled = true;
      status.textContent = 'Adding to basket…';
      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Could not add the kit.');
        }
        window.location.assign('/cart');
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    }
  }

  customElements.define('aquarium-builder-kit', AquariumBuilderKit);
})();